
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fabrics",
      function () {
        return require("private-next-pages/fabrics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fabrics"])
      });
    }
  